import React, { useContext, useRef, useState, useEffect, useLayoutEffect } from 'react';
import { View, Button as Button$1, Box, usePatronTheme, Stack, Text, useObserver, ChevronDownIcon, VisuallyHidden, Spinner, ObserverProvider, LoadingButton, Tooltip, DropdownItem, Inline, Dropdown, ButtonGroup, DropdownButton, DropdownList as DropdownList$1, Columns, Column, Divider, CloseButton, PatronThemeProvider } from '@unibuddy/patron';
import styled, { ThemeContext, css } from 'styled-components';
import AutosizeTextarea from 'react-textarea-autosize';
import 'intersection-observer';
import { usePress } from '@react-aria/interactions';
import deepMerge from 'lodash-es/merge';
import Linkify from 'react-linkify';
import Hammer from 'hammerjs';

function useChatTheme() {
  return useContext(ThemeContext);
}

var ChatFooter = function ChatFooter(_ref) {
  var _theme$chat, _theme$chat2;

  var children = _ref.children;
  var theme = useChatTheme();
  return React.createElement(View, {
    position: "relative",
    padding: "small",
    flexShrink: 0,
    bgColor: theme == null ? void 0 : (_theme$chat = theme.chat) == null ? void 0 : _theme$chat.footer.backgroundColor,
    brb: theme == null ? void 0 : (_theme$chat2 = theme.chat) == null ? void 0 : _theme$chat2.footer.brb
  }, children);
};

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function mergeRefs(refs) {
  return function (value) {
    refs.forEach(function (ref) {
      if (typeof ref === "function") {
        ref(value);
      }

      if (ref != null) {
        ref.current = value;
      }
    });
  };
}

function SendIcon(props) {
  return React.createElement("svg", Object.assign({
    "aria-hidden": true,
    width: "1em",
    height: "1em",
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false"
  }, props), React.createElement("path", {
    d: "M10.99 9.063H5.937a1.2 1.2 0 00-1 .534L1 15.512a1.2 1.2 0 001.534 1.735l14.136-7.112a1.201 1.201 0 000-2.141L2.484.882A1.2 1.2 0 00.952 2.62l2.726 3.947",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var MemoSendIcon = /*#__PURE__*/React.memo(SendIcon);

var _templateObject, _templateObject2;
var Button = /*#__PURE__*/styled(Button$1)(_templateObject || (_templateObject = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    & svg {\n        margin: 0;\n        font-size: 16px;\n    }\n\n    ", "\n"])), function (_ref) {
  var isActive = _ref.isActive;
  if (!isActive) return;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n                svg {\n                    transition: 0.25s ease all;\n                    transform: rotate(-45deg);\n                    transform-origin: center;\n                    will-change: transform;\n                }\n            }"])));
});
function SendButton(_ref2) {
  var hasValue = _ref2.hasValue,
      onClickSubmit = _ref2.onClickSubmit,
      disabled = _ref2.disabled;
  return React.createElement(Button, {
    color: hasValue ? "activeChat" : "chat",
    onClick: onClickSubmit,
    type: "submit",
    "aria-label": "Send message",
    isActive: hasValue,
    iconOnly: true,
    size: "md",
    round: true,
    disabled: disabled
  }, React.createElement(MemoSendIcon, {
    style: {
      marginRight: -2,
      marginTop: -1
    }
  }));
}

var _templateObject$1, _templateObject2$1, _templateObject3;
var InputWrapper = /*#__PURE__*/styled.div(_templateObject$1 || (_templateObject$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    box-shadow: ", ";\n    background-color: ", ";\n    margin-right: ", ";\n    border-radius: ", ";\n    flex: 1;\n"])), function (_ref) {
  var _theme$chat, _theme$chat$input;

  var theme = _ref.theme;
  return theme == null ? void 0 : (_theme$chat = theme.chat) == null ? void 0 : (_theme$chat$input = _theme$chat.input) == null ? void 0 : _theme$chat$input.boxShadow;
}, function (_ref2) {
  var _theme$chat2;

  var theme = _ref2.theme;
  return theme == null ? void 0 : (_theme$chat2 = theme.chat) == null ? void 0 : _theme$chat2.input.backgroundColor;
}, function (_ref3) {
  var $sendButtonInside = _ref3.$sendButtonInside;
  return $sendButtonInside ? "none" : "8px";
}, function (_ref4) {
  var _theme$chat3;

  var theme = _ref4.theme;
  return theme == null ? void 0 : (_theme$chat3 = theme.chat) == null ? void 0 : _theme$chat3.input.borderRadius;
});
var Input = /*#__PURE__*/styled(AutosizeTextarea)(_templateObject2$1 || (_templateObject2$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    padding: 16px;\n    padding-left: 20px;\n    border-radius: ", ";\n    box-sizing: border-box;\n    font: inherit;\n    min-height: ", ";\n    padding-top: ", ";\n    padding-bottom: ", ";\n    scroll-padding: ", ";\n    background-color: ", ";\n    color: ", ";\n    border: 0;\n    outline: 0;\n    resize: none;\n    flex-grow: 1;\n\n    &::placeholder {\n        color: ", ";\n    }\n\n    &[disabled] {\n        border-color: transparent;\n        background-color: ", ";\n        cursor: not-allowed;\n    }\n"])), function (_ref5) {
  var _theme$chat4;

  var theme = _ref5.theme;
  return theme == null ? void 0 : (_theme$chat4 = theme.chat) == null ? void 0 : _theme$chat4.input.borderRadius;
}, function (_ref6) {
  var _theme$Button;

  var theme = _ref6.theme;
  return theme == null ? void 0 : (_theme$Button = theme.Button) == null ? void 0 : _theme$Button.iconOnly.heights.md;
}, function (_ref7) {
  var _theme$chat5;

  var theme = _ref7.theme;
  return theme == null ? void 0 : (_theme$chat5 = theme.chat) == null ? void 0 : _theme$chat5.input.paddingTop;
}, function (_ref8) {
  var _theme$chat6;

  var theme = _ref8.theme;
  return theme == null ? void 0 : (_theme$chat6 = theme.chat) == null ? void 0 : _theme$chat6.input.paddingBottom;
}, function (_ref9) {
  var _theme$chat7;

  var theme = _ref9.theme;
  return theme == null ? void 0 : (_theme$chat7 = theme.chat) == null ? void 0 : _theme$chat7.input.paddingTop;
}, function (_ref10) {
  var _theme$chat8;

  var theme = _ref10.theme;
  return theme == null ? void 0 : (_theme$chat8 = theme.chat) == null ? void 0 : _theme$chat8.input.backgroundColor;
}, function (_ref11) {
  var _theme$chat9;

  var theme = _ref11.theme;
  return theme == null ? void 0 : (_theme$chat9 = theme.chat) == null ? void 0 : _theme$chat9.input.color;
}, function (_ref12) {
  var _theme$chat10, _theme$chat10$input;

  var theme = _ref12.theme;
  return theme == null ? void 0 : (_theme$chat10 = theme.chat) == null ? void 0 : (_theme$chat10$input = _theme$chat10.input) == null ? void 0 : _theme$chat10$input.placeholderColor;
}, function (_ref13) {
  var _theme$chat11;

  var theme = _ref13.theme;
  return theme == null ? void 0 : (_theme$chat11 = theme.chat) == null ? void 0 : _theme$chat11.disabled.backgroundColor;
});
var Form = /*#__PURE__*/styled.form(_templateObject3 || (_templateObject3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    display: flex;\n    justify-content: flex-end;\n"])));

var getHasValue = function getHasValue(value) {
  var input = value.trim();
  return typeof input === "string" && input.length > 0;
};

var ChatInput = /*#__PURE__*/React.forwardRef(function (_ref14, ref) {
  var onSend = _ref14.onSend,
      value = _ref14.value,
      onChangeText = _ref14.onChangeText,
      disabled = _ref14.disabled,
      addonTop = _ref14.addonTop,
      addonBottom = _ref14.addonBottom,
      addonRight = _ref14.addonRight,
      addonLeft = _ref14.addonLeft,
      shouldAllowSend = _ref14.shouldAllowSend,
      onFocus = _ref14.onFocus,
      onBlur = _ref14.onBlur,
      _ref14$placeholder = _ref14.placeholder,
      placeholder = _ref14$placeholder === void 0 ? "Type your message..." : _ref14$placeholder,
      _ref14$sendButtonInsi = _ref14.sendButtonInside,
      sendButtonInside = _ref14$sendButtonInsi === void 0 ? false : _ref14$sendButtonInsi;
  var textAreaRef = useRef();
  var inputRef = mergeRefs([textAreaRef, ref]);
  var isMousePrimaryDevice = matchMedia("(hover: hover)").matches;

  var _useState = useState(value),
      innerValue = _useState[0],
      setInnerValue = _useState[1];

  var finalValue = onChangeText ? value : innerValue;
  var finalOnChangeText = onChangeText || setInnerValue;
  var hasValue = shouldAllowSend ? shouldAllowSend() : getHasValue(finalValue);

  var onChange = function onChange(e) {
    finalOnChangeText(e.target.value);
  };

  var onKeyDown = function onKeyDown(e) {
    // By default in a textarea `Enter` key adds a new row instead of submitting the form
    // We want to change this default behavior to submit by default. If the user wants to add
    // a row, they can still do so with `shift+enter` combo.
    if (isMousePrimaryDevice && e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  }; // We still need this handler despite the above change in default behavior because
  // the user can still submit the form by pressing `cmd+enter`.


  var onSubmit = function onSubmit(e) {
    e.preventDefault();
    sendMessage();
  };

  var sendMessage = function sendMessage() {
    if (!hasValue) return;
    onSend(finalValue);
    finalOnChangeText("");
  }; // We autofocus the input after clicking send as a convenience for users that don't
  // know they can submit by pressing enter and keep the focus on the input by default.


  var onClickSubmit = function onClickSubmit() {
    var _textAreaRef$current;

    textAreaRef == null ? void 0 : (_textAreaRef$current = textAreaRef.current) == null ? void 0 : _textAreaRef$current.focus({
      preventScroll: true
    });
  };

  return (// action="POST" turns the "action" button blue on iPhone keyboards
    React.createElement(Form, {
      action: "POST",
      onSubmit: onSubmit,
      name: "sendChatMessage"
    }, React.createElement(InputWrapper, {
      "$sendButtonInside": sendButtonInside
    }, addonTop ? addonTop : null, React.createElement(Box, {
      display: "flex"
    }, addonLeft ? addonLeft : null, React.createElement(Input, {
      ref: inputRef,
      onKeyDown: onKeyDown,
      maxRows: 4,
      value: finalValue,
      onChange: onChange,
      disabled: disabled,
      "aria-label": "Type your message here",
      placeholder: placeholder,
      onFocus: onFocus,
      onBlur: onBlur
    }), addonRight ? addonRight : null, sendButtonInside ? React.createElement(SendButton, {
      hasValue: hasValue,
      onClickSubmit: onClickSubmit,
      disabled: disabled
    }) : null), addonBottom ? addonBottom : null), !sendButtonInside ? React.createElement(View, {
      flexShrink: 0
    }, React.createElement(SendButton, {
      hasValue: hasValue,
      onClickSubmit: onClickSubmit,
      disabled: disabled
    })) : null)
  );
});

var noop = function noop() {};

ChatInput.defaultProps = {
  onSend: noop,
  onBlur: noop,
  onFocus: noop,
  value: "",
  disabled: false
};

var getMessageSequencePosition = function getMessageSequencePosition(_ref) {
  var currentMessage = _ref.currentMessage,
      nextMessage = _ref.nextMessage,
      previousMessage = _ref.previousMessage;
  var currentSender = currentMessage.sender.id;
  var prevSender = previousMessage == null ? void 0 : previousMessage.sender.id;
  var nextSender = nextMessage == null ? void 0 : nextMessage.sender.id; // This message is the first message in a sequence which is labelled as "top" when:
  // There are no previous messages or the previous message is authored by a different author and there is another message following this one from the same author.

  if ((!prevSender || prevSender !== currentSender) && nextSender && nextSender === currentSender) return "top"; // This message is not the first or last in the sequence which is labelled as "middle" when:
  // Both a previous and a next message exist and both are authored by the current author.

  if (prevSender && prevSender === currentSender && nextSender && nextSender === currentSender) return "middle"; // This message is the last in the sequence which is labelled as "bottom" when:
  // A previous message exists and is authored by the current author and a following message is from a different author, if it exists.

  if (prevSender && prevSender === currentSender && (!nextSender || nextSender !== currentSender)) return "bottom"; // In all other cases the message is not in a sequence and considered an "orphan":

  return "orphan";
};
var MessageRow = function MessageRow(_ref2) {
  var children = _ref2.children,
      as = _ref2.as,
      _ref2$align = _ref2.align,
      align = _ref2$align === void 0 ? "left" : _ref2$align,
      avatar = _ref2.avatar,
      position = _ref2.position,
      addonTop = _ref2.addonTop,
      addonBottom = _ref2.addonBottom,
      reactions = _ref2.reactions;
  return React.createElement(Box, {
    as: as,
    display: "flex",
    paddingX: ["xxsmall", "xsmall", "small"],
    marginBottom: position === "bottom" || position === "orphan" ? "medium" : "xsmall",
    alignItems: "flex-start",
    flexDirection: align === "right" ? "row-reverse" : "row"
  }, avatar, React.createElement(View, {
    alignItems: align === "right" ? "flex-end" : "flex-start"
  }, addonTop ? React.createElement(Box, {
    paddingBottom: "xsmall"
  }, addonTop) : null, children, reactions, addonBottom ? React.createElement(Box, {
    paddingBottom: "xsmall"
  }, addonBottom) : null));
};
var MessageQuote = function MessageQuote(_ref3) {
  var _theme$chat, _theme$chat$quote, _theme$chat2, _theme$chat2$quote, _theme$chat3, _theme$chat3$quote, _theme$chat4, _theme$chat4$quote, _theme$chat5, _theme$chat5$quote, _theme$chat6, _theme$chat6$quote, _theme$chat7, _theme$chat7$quote;

  var children = _ref3.children,
      author = _ref3.author,
      align = _ref3.align,
      isSenderBlocked = _ref3.isSenderBlocked,
      highlight = _ref3.highlight;
  var theme = usePatronTheme();

  var getQuoteText = function getQuoteText(text, isSenderBlocked) {
    if (isSenderBlocked) {
      return "This user was removed";
    }

    if (typeof text === "string" && text.length > 120) {
      return text.substring(0, 120);
    }

    return text;
  };

  return React.createElement(Box, {
    display: "flex"
  }, highlight ? React.createElement(Box, {
    w: 5,
    bgColor: theme == null ? void 0 : (_theme$chat = theme.chat) == null ? void 0 : (_theme$chat$quote = _theme$chat.quote) == null ? void 0 : _theme$chat$quote.highlightColor,
    brl: "xsmall",
    flexShrink: 0
  }) : null, React.createElement(View, {
    brr: highlight ? "xsmall" : undefined,
    borderRadius: !highlight ? "xsmall" : undefined,
    bgColor: align === "right" ? theme == null ? void 0 : (_theme$chat2 = theme.chat) == null ? void 0 : (_theme$chat2$quote = _theme$chat2.quote) == null ? void 0 : _theme$chat2$quote.backgroundColor : theme == null ? void 0 : (_theme$chat3 = theme.chat) == null ? void 0 : (_theme$chat3$quote = _theme$chat3.quote) == null ? void 0 : _theme$chat3$quote.altBackgroundColor,
    padding: "small",
    flexGrow: "1",
    flexShrink: "1"
  }, React.createElement(Stack, {
    space: "small"
  }, React.createElement(Text, {
    color: align === "right" ? theme == null ? void 0 : (_theme$chat4 = theme.chat) == null ? void 0 : (_theme$chat4$quote = _theme$chat4.quote) == null ? void 0 : _theme$chat4$quote.authorColor : theme == null ? void 0 : (_theme$chat5 = theme.chat) == null ? void 0 : (_theme$chat5$quote = _theme$chat5.quote) == null ? void 0 : _theme$chat5$quote.altAuthorColor
  }, author), React.createElement(Text, {
    color: align === "right" ? theme == null ? void 0 : (_theme$chat6 = theme.chat) == null ? void 0 : (_theme$chat6$quote = _theme$chat6.quote) == null ? void 0 : _theme$chat6$quote.bodyColor : theme == null ? void 0 : (_theme$chat7 = theme.chat) == null ? void 0 : (_theme$chat7$quote = _theme$chat7.quote) == null ? void 0 : _theme$chat7$quote.altBodyColor
  }, getQuoteText(children, isSenderBlocked)))));
};

/**
 * Determines whether the given user agent is for iOS
 * @param userAgent {string}
 * @returns {boolean}
 */
// eslint-disable-next-line import/prefer-default-export
function isIOS(userAgent) {
  return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
}

/**
 * since hooks don't support storing of previous values natively
 * wee need a custom hook for that.
 *
 * @export
 * @param {*} value
 * @returns
 */

function usePrevious(value) {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  var ref = useRef(); // Store current value in ref

  useEffect(function () {
    ref.current = value;
  }, [value]); // Only re-run if value changes
  // Return previous value (happens before update in useEffect above)

  return ref.current;
}

/**
 * useRestoreScrollPosition restores to the scroll position after more messages
 * are fetched.
 *
 * In the first effect we use useLayoutEffect instead of useEffect because we have to synchronously
 * respond to changes in the rendering of messages. As soon as "new" messages are rendered
 * we restore scroll to the last known position position.
 *
 * In the second effect we are tracking the users scroll position while we are loading the new messages.
 * If the network conditions are not good the loading might take a while, and therefore the last known
 * scroll position might change because the user might scroll up and down freely.
 *
 * @param {*} scrollRef
 * @param {*} messages
 * @returns
 */

function useRestoreScrollPosition(_ref) {
  var previousOldestMessage = _ref.previousOldestMessage,
      scrollRef = _ref.scrollRef,
      messages = _ref.messages,
      loading = _ref.loading;
  var scrollPosition = useRef(0); // Messages prop can change for an arbitrarily different number of reasons but the first message id
  // only changes in one scenario, when we fetch more. This value transition is a good indicator
  // that we have fetched more messages. We should only run this effect when we have just fetched more.

  var previousMessages = usePrevious(messages);
  var isOldestMessageDifferent = previousMessages && previousMessages.length > 0 && messages && messages.length > 0 && messages[0].id !== previousMessages[0].id;
  useLayoutEffect(function () {
    if (!isOldestMessageDifferent || !previousOldestMessage.current) return; // We set this style in order to prevent iOS bounce effect interferring with our
    // scroll restore. The bounce effect would have continued to change the scrollTop
    // after we have set it.
    // scrollRef.current.style["-webkit-overflow-scrolling"] = "auto";
    // We restore the scroll position by looking up the new offsetTop of the previous
    // oldest message and apply that as

    var newScrollPosition = previousOldestMessage.current.offsetTop + scrollPosition.current;
    scrollRef.current.scrollTop = newScrollPosition; // Now it is safe to restore the bounce effect because removing it earlier resets
    // the in progress animation and we start again from zero. It causes some jank on iOS
    // during the bounce animation but there is no way to prevent the bounce interferring
    // with our scroll restore at the moment (Zarko, 2019-11-06).
    // scrollRef.current.style["-webkit-overflow-scrolling"] = "touch";
  }, [messages] // eslint-disable-line
  ); // We only need to track the scroll position when the fetch is in progress.

  useEffect(function () {
    if (!loading) return;
    scrollPosition.current = scrollRef.current.scrollTop;

    var onScroll = function onScroll(e) {
      scrollPosition.current = e.target.scrollTop;
    };

    scrollRef.current.addEventListener("scroll", onScroll, {
      passive: true
    });
    return function () {
      return scrollRef.current.removeEventListener("scroll", onScroll);
    };
  }, [scrollRef, loading]);
}

var _templateObject$2, _templateObject2$2, _templateObject3$1, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;
var Wrapper = /*#__PURE__*/styled.div(_templateObject$2 || (_templateObject$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background-color: ", ";\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n    position: relative;\n"])), function (_ref) {
  var _theme$chat;

  var theme = _ref.theme;
  return (_theme$chat = theme.chat) == null ? void 0 : _theme$chat.scroll.backgroundColor;
});
var LoadingSpinner = /*#__PURE__*/styled.div(_templateObject2$2 || (_templateObject2$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background: #fff;\n    padding: 1em;\n    position: absolute;\n    top: 1em;\n    left: 50%;\n    border-radius: 0.25em;\n    box-shadow: 0 2px 4px rgba(70, 70, 70, 0.2);\n    transform: translate3d(-50%, -100%, 0);\n    opacity: 0;\n    pointer-events: none;\n    z-index: 1;\n    transition: 0.2s ease all;\n    ", "\n"])), function (_ref2) {
  var show = _ref2.show;
  return show ? css(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteralLoose(["\n                  opacity: 1;\n                  transform: translate3d(-50%, 0, 0);\n              "]))) : null;
});
var Scroll = /*#__PURE__*/styled.div(_templateObject4 || (_templateObject4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    flex: 1;\n    overflow-y: auto;\n    overflow-x: hidden;\n    -webkit-overflow-scrolling: touch;\n\n    ", "\n"])), function (_ref3) {
  var blur = _ref3.blur;
  return blur ? css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n                  padding-bottom: \"1em\";\n                  &:after {\n                      content: \"\";\n                      position: absolute;\n                      bottom: -1px; /* fix weird chrome issue */\n                      left: 0;\n                      height: 32px;\n                      width: 100%;\n                      z-index: 1;\n                      background-image: ", ";\n                  }\n              "])), function (_ref4) {
    var _theme$chat2;

    var theme = _ref4.theme;
    return "linear-gradient(0deg, " + ((_theme$chat2 = theme.chat) == null ? void 0 : _theme$chat2.scroll.backgroundColor) + ", rgba(255, 255, 255, 0))";
  }) : null;
});
var ScrollToBottom = /*#__PURE__*/styled.div(_templateObject6 || (_templateObject6 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    position: absolute;\n    bottom: 1em;\n    right: 1em;\n    z-index: 2;\n    opacity: 0;\n    pointer-events: none;\n    transition: 0.1s ease all;\n    transition-delay: 0.2;\n    svg {\n        font-size: 22px;\n        margin-top: 2px;\n        margin-left: 2px;\n    }\n    ", "\n"])), function (_ref5) {
  var show = _ref5.show;
  return show ? css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n                  opacity: 1;\n                  pointer-events: all;\n              "]))) : null;
});
var Inner = /*#__PURE__*/styled.div(_templateObject8 || (_templateObject8 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    position: relative;\n"])));
var LoadMoreContainer = /*#__PURE__*/styled.div(_templateObject9 || (_templateObject9 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 1rem;\n"])));
var MessageList = /*#__PURE__*/styled.ul(_templateObject10 || (_templateObject10 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    position: relative;\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    > li:first-child {\n        margin-top: 1em;\n    }\n    > li:last-child {\n        margin-bottom: 1em;\n    }\n"])));
var FirstItem = /*#__PURE__*/styled.div(_templateObject11 || (_templateObject11 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    margin: 0;\n    position: absolute;\n    left: 0;\n    right: 0;\n    height: 2em;\n    opacity: 0;\n    pointer-events: none;\n    z-index: 2;\n    top: 100px;\n"])));
var LastItem = /*#__PURE__*/styled(FirstItem)(_templateObject12 || (_templateObject12 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    top: auto;\n    bottom: 0;\n    height: 4em;\n"])));
/**
 * The purpose of this component is to control the scroll behavior of the chat ui.
 * We add a "lastItem" comp at the bottom of the chat and use that component as an
 * anchor to scroll to. First and last items are "spies" that we use to detect if the
 * user has scrolled in or out of the top and bottom areas. We use IntersectionObserver
 * to achieve this without the performance penalty of onScroll listener.
 *
 * Functionality breakdown:
 * - after the first messages are loaded we scroll to bottom
 * - if a new message comes in we scroll to bottom
 * - if the user scrolls up manually we disable the automatic scroll, and
 * show a button to scroll back to bottom
 * - if the user scrolls to top we call fetchMore, once it completes and new messages are rendered
 * we restore the scroll position
 */

function ChatScroll(_ref6) {
  var children = _ref6.children,
      messages = _ref6.messages,
      fetchMore = _ref6.fetchMore,
      loading = _ref6.loading,
      hasMoreMessages = _ref6.hasMoreMessages,
      notifications = _ref6.notifications,
      blur = _ref6.blur;
  var iOS = isIOS(navigator.userAgent);

  var _React$useState = React.useState(false),
      isAutoScrollDisabled = _React$useState[0],
      setAutoScrollDisabled = _React$useState[1];

  var scrollRef = React.useRef(null);
  var listRef = React.useRef(null);
  var scrollContainerBottomAreaRef = React.useRef(null);
  var scrollContainerTopAreaRef = React.useRef(null);
  var previousOldestMessage = React.useRef();
  useRestoreScrollPosition({
    previousOldestMessage: previousOldestMessage,
    scrollRef: scrollRef,
    messages: messages,
    loading: loading
  }); // We only show the button if the user has scrolled up manually.

  var showScrollToBottomButton = isAutoScrollDisabled;
  /**
   * When the user scrolls manually up, we disable the programmatic scroll so we don't
   * interfere with the user's scroll.
   */

  var onScrollBottom = React.useCallback(function (_ref7) {
    var bottomScrollSpy = _ref7[0];
    setAutoScrollDisabled(!bottomScrollSpy.isIntersecting);
  }, [setAutoScrollDisabled]);
  /**
   * Once the user has scrolled near the top of the chat call fetchMore.
   * When fetchMore completes restore the scroll position.
   */

  var onScrollTop = React.useCallback(function (_ref8) {
    var topScrollSpy = _ref8[0];

    if (fetchMore && topScrollSpy.isIntersecting) {
      previousOldestMessage.current = listRef.current.firstChild;
      fetchMore();
    }
  }, [fetchMore]);

  var onFetchMore = function onFetchMore() {
    previousOldestMessage.current = listRef.current.firstChild;
    fetchMore();
  };
  /**
   * Animate scroll to bottom if it is supported by the platform
   */


  var scrollToBottom = function scrollToBottom() {
    scrollContainerBottomAreaRef.current.scrollIntoView({
      behavior: "smooth",
      block: "nearest"
    });
  };
  /**
   * Scroll to bottom instantly
   */


  var snapToBottom = React.useCallback(function () {
    scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
  }, []);
  useObserver(onScrollBottom, {
    disabled: loading,
    root: scrollRef.current,
    target: scrollContainerBottomAreaRef
  });
  useObserver(onScrollTop, {
    disabled: iOS || loading,
    root: scrollRef.current,
    target: scrollContainerTopAreaRef
  }); // Scroll to bottom programmatically whenever the messages change.
  // Only do this when the user hasn't scrolled up manually.

  React.useEffect(function () {
    if (isAutoScrollDisabled || messages.length < 1) return;
    snapToBottom();
  }, [isAutoScrollDisabled, messages, snapToBottom]);
  var prevHeight = useRef(0);
  useLayoutEffect(function () {
    if (!("ResizeObserver" in window) || isAutoScrollDisabled) return;
    var observer = new ResizeObserver(function (_ref9) {
      var data = _ref9[0];
      var newHeight = data.contentRect.height;

      if (prevHeight.current !== 0 && newHeight !== prevHeight.current) {
        snapToBottom();
      }

      prevHeight.current = newHeight;
    });
    observer.observe(scrollRef.current);
    return function () {
      observer.disconnect();
    };
  }, [isAutoScrollDisabled, snapToBottom]);
  return React.createElement(Wrapper, null, React.createElement(ScrollToBottom, {
    show: showScrollToBottomButton
  }, React.createElement(Button$1, {
    onClick: scrollToBottom,
    color: "light",
    "aria-label": "Scroll to bottom",
    round: true,
    iconOnly: true,
    elevation: 1,
    tabIndex: showScrollToBottomButton ? 0 : -1
  }, React.createElement(ChevronDownIcon, {
    "aria-hidden": true
  })), notifications), !iOS && React.createElement(LoadingSpinner, {
    show: loading
  }, React.createElement(VisuallyHidden, null, "Loading"), " ", React.createElement(Spinner, {
    "aria-hidden": true,
    size: 24
  })), React.createElement(ObserverProvider, {
    rootRef: scrollRef
  }, React.createElement(Scroll, {
    "data-test-id": "chat-body-scroll",
    ref: scrollRef,
    blur: blur
  }, React.createElement(Inner, null, React.createElement(FirstItem, {
    "data-test-id": "chat-body-first-item",
    ref: scrollContainerTopAreaRef
  }), hasMoreMessages && iOS && fetchMore && React.createElement(LoadMoreContainer, null, React.createElement(LoadingButton, {
    round: true,
    color: "light",
    elevation: 1,
    onClick: onFetchMore,
    loading: loading,
    disabled: loading
  }, "Load More")), React.createElement(MessageList, {
    ref: listRef
  }, children), React.createElement(LastItem, {
    "data-test-id": "chat-body-last-item",
    ref: scrollContainerBottomAreaRef
  })))));
}

var ChatContainer = function ChatContainer(props) {
  return React.createElement(View, Object.assign({
    flex: "1"
  }, props));
};

var bubblePadding = ["small"];
var getSharedBubbleProps = function getSharedBubbleProps(_ref) {
  var _theme$chat, _theme$chat2;

  var position = _ref.position,
      align = _ref.align,
      theme = _ref.theme;
  return {
    brt: position === "top" ? "small" : undefined,
    brr: align === "right" ? undefined : "small",
    brl: align === "right" ? "small" : undefined,
    brb: position === "bottom" || position === "orphan" ? "small" : undefined,
    padding: bubblePadding,
    bgColor: align === "right" ? theme == null ? void 0 : (_theme$chat = theme.chat) == null ? void 0 : _theme$chat.message.backgroundColor : theme == null ? void 0 : (_theme$chat2 = theme.chat) == null ? void 0 : _theme$chat2.message.altBackgroundColor,
    maxW: ["75vw", 400],
    minW: "auto"
  };
};

var Like = function Like(props) {
  return React.createElement("svg", Object.assign({
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "likeOutline"
  }, props), React.createElement("path", {
    d: "M15.9988 7.24082C15.3916 5.79283 13.2663 5.79283 11.9585 5.86289C12.1453 4.85864 12.3322 3.1304 12.0286 2.49982C11.7717 1.93931 11.2111 1.56564 10.5339 1.49557C10.5339 1.49557 10.4871 1.49557 10.4171 1.49557C9.78651 1.49557 9.22599 1.75248 8.92238 2.31299C7.54446 4.43826 6.16654 5.93296 5.67609 6.42341H2.7334C2.05612 6.42341 1.49561 6.98392 1.49561 7.6612V13.2663C1.49561 13.9436 2.05612 14.5041 2.7334 14.5041H3.99455H4.92874C4.92874 14.5041 7.10072 15.4383 9.03916 15.5784C9.59967 15.6018 9.59967 15.5784 9.90328 15.5784C11.5848 15.5784 13.1496 15.2048 14.2706 14.4574C16.3492 13.0094 16.9797 9.27267 15.9988 7.24082ZM2.7334 7.6612H3.9712V13.2663H2.7334V7.6612ZM13.5233 13.3831C12.6591 13.9436 11.2812 14.3173 9.85657 14.3173H9.34277C9.17929 14.3173 9.03916 14.3173 8.87568 14.2939C7.10072 14.0837 6.28331 13.8268 5.88628 13.6633C5.74615 13.6166 5.62938 13.5466 5.48925 13.4532L5.23235 13.2663V7.6612H5.74615C6.04976 7.6612 6.35337 7.54443 6.61027 7.28753C7.10072 6.72702 8.54871 5.16226 10.0201 2.94356C10.1368 2.75673 10.3237 2.68666 10.5105 2.68666C10.6973 2.68666 10.8842 2.73337 11.0009 2.99027C11.0477 3.17711 11.0477 4.15801 10.744 5.9096L10.5572 6.75037C10.5339 6.8905 10.6273 7.03063 10.7908 7.03063H11.9351C12.7993 6.98392 14.6209 6.98392 14.9245 7.6612C15.6018 9.27267 15.1114 12.3788 13.5233 13.3831Z",
    fill: "#404446"
  }));
};
var LikeFilled = function LikeFilled(props) {
  return React.createElement("svg", Object.assign({
    width: "14",
    height: "13",
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "likeFilled"
  }, props), React.createElement("path", {
    d: "M13.2209 5.43647C12.6811 4.14937 10.792 4.14937 9.62944 4.21165C9.79552 3.31899 9.9616 1.78277 9.69172 1.22226C9.46336 0.724024 8.96513 0.391869 8.3631 0.32959C8.3631 0.32959 8.32158 0.32959 8.2593 0.32959C7.69879 0.32959 7.20056 0.557946 6.93068 1.05618C5.70586 2.94531 4.48104 4.27393 4.04509 4.70988H1.42937C0.827334 4.70988 0.329102 5.20812 0.329102 5.81015V10.7925C0.329102 11.3945 0.827334 11.8927 1.42937 11.8927H2.55039H3.38078C3.38078 11.8927 5.31143 12.7231 7.03448 12.8477C7.53271 12.8684 7.53271 12.8477 7.80259 12.8477C9.29729 12.8477 10.6882 12.5155 11.6847 11.8512C13.5323 10.5641 14.0928 7.24257 13.2209 5.43647ZM1.42937 5.81015H2.52963V10.7925H1.42937V5.81015Z",
    fill: "#404446"
  }));
};
var Dustbin = function Dustbin() {
  return React.createElement("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M4.26611 4.20032H13.6808",
    stroke: "#404446",
    strokeWidth: "1.10915",
    strokeMiterlimit: "10",
    strokeLinecap: "round"
  }), React.createElement("path", {
    d: "M7.18475 3.8182C7.19821 3.35276 7.39257 2.9109 7.72655 2.58644C8.06053 2.26198 8.50783 2.08047 8.97346 2.08047C9.4391 2.08047 9.8864 2.26198 10.2204 2.58644C10.5544 2.9109 10.7487 3.35276 10.7622 3.8182",
    stroke: "#404446",
    strokeWidth: "1.10915",
    strokeMiterlimit: "10",
    strokeLinecap: "round"
  }), React.createElement("path", {
    d: "M13.6845 6.46091L12.678 14.0644C12.516 14.6387 12.1592 15.1388 11.6688 15.4788C11.1785 15.8188 10.5851 15.9776 9.99043 15.9279H8.00131C7.40694 15.9778 6.81374 15.8192 6.32349 15.4795C5.83325 15.1397 5.47652 14.6399 5.31451 14.0659L4.26611 6.46091",
    stroke: "#404446",
    strokeWidth: "1.10915",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var Menu = function Menu() {
  return React.createElement("svg", {
    width: "19",
    height: "18",
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("ellipse", {
    cx: "8.97751",
    cy: "8.97345",
    rx: "1.49624",
    ry: "1.49558",
    fill: "#3E3E48"
  }), React.createElement("ellipse", {
    cx: "8.97751",
    cy: "3.73894",
    rx: "1.49624",
    ry: "1.49558",
    fill: "#3E3E48"
  }), React.createElement("ellipse", {
    cx: "8.97751",
    cy: "14.208",
    rx: "1.49624",
    ry: "1.49558",
    fill: "#3E3E48"
  }));
};
var CopyToClipboard = function CopyToClipboard() {
  return React.createElement("svg", {
    width: "19",
    height: "18",
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M11.2802 2.60156C11.7763 2.60156 12.252 2.79852 12.6027 3.14911C12.9535 3.4997 13.1505 3.97521 13.1505 4.47103V11.1114L8.94609 15.3139H6.7915C6.29546 15.3139 5.81974 15.117 5.46899 14.7664C5.11824 14.4158 4.92119 13.9403 4.92119 13.4445V4.47103C4.92119 3.97521 5.11824 3.4997 5.46899 3.14911C5.81974 2.79852 6.29546 2.60156 6.7915 2.60156H11.2802V2.60156ZM11.2802 1.47987H6.7915C5.99784 1.47987 5.23669 1.79501 4.67549 2.35596C4.11429 2.91691 3.79901 3.67772 3.79901 4.47103V13.4445C3.79901 14.2378 4.11429 14.9986 4.67549 15.5595C5.23669 16.1205 5.99784 16.4356 6.7915 16.4356H9.1017C9.3001 16.4356 9.49036 16.3568 9.63062 16.2165L14.0535 11.7956C14.1231 11.7261 14.1783 11.6436 14.2159 11.5527C14.2535 11.4619 14.2728 11.3645 14.2727 11.2662V4.47103C14.2727 3.67772 13.9574 2.91691 13.3962 2.35596C12.835 1.79501 12.0739 1.47987 11.2802 1.47987V1.47987Z",
    fill: "#404446"
  }), React.createElement("path", {
    d: "M6.7915 4.66096H11.2802",
    stroke: "#404446",
    strokeWidth: "1.1255",
    strokeMiterlimit: "10",
    strokeLinecap: "round"
  }), React.createElement("path", {
    d: "M6.7915 6.84525H8.66929",
    stroke: "#404446",
    strokeWidth: "1.1255",
    strokeMiterlimit: "10",
    strokeLinecap: "round"
  }), React.createElement("path", {
    d: "M9.41138 15.8419V12.2727C9.41138 12.0881 9.48476 11.911 9.61538 11.7804C9.746 11.6499 9.92315 11.5765 10.1079 11.5765H13.7063",
    stroke: "#404446",
    strokeWidth: "1.1255",
    strokeMiterlimit: "10"
  }));
};
var Reply = function Reply() {
  return React.createElement("svg", {
    width: "19",
    height: "18",
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M2.36182 13.4445C2.36152 12.5137 2.54467 11.5921 2.90081 10.7321C3.25694 9.8721 3.77908 9.09068 4.4374 8.43244C5.09573 7.7742 5.87733 7.25205 6.73758 6.8958C7.59783 6.53955 8.51987 6.35619 9.45102 6.35619H11.5847V4.25117L15.8669 8.80445L11.5847 13.4445V11.3021H9.47646C5.56079 11.3021 3.79073 12.1643 2.38725 13.4445",
    stroke: "#404446",
    strokeWidth: "1.1255",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var Report = function Report() {
  return React.createElement("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M9.06851 2.58286C10.3298 2.58272 11.5628 2.9566 12.6117 3.65724C13.6605 4.35788 14.478 5.3538 14.9607 6.51906C15.4435 7.68431 15.5699 8.96656 15.3239 10.2037C15.078 11.4407 14.4707 12.5771 13.5788 13.469C12.687 14.361 11.5507 14.9684 10.3136 15.2145C9.07658 15.4607 7.79432 15.3344 6.629 14.8518C5.46369 14.3691 4.46767 13.5518 3.76691 12.503C3.06615 11.4543 2.69212 10.2213 2.69212 8.96C2.6941 7.26928 3.36661 5.64839 4.56212 4.45287C5.75764 3.25735 7.37854 2.58484 9.06925 2.58286H9.06851ZM9.06925 1.46118C7.58613 1.46118 6.13631 1.90098 4.90314 2.72496C3.66996 3.54894 2.70882 4.7201 2.14125 6.09032C1.57368 7.46055 1.42518 8.96832 1.71453 10.4229C2.00387 11.8776 2.71806 13.2137 3.76679 14.2625C4.81552 15.3112 6.15168 16.0254 7.60631 16.3147C9.06094 16.6041 10.5687 16.4556 11.9389 15.888C13.3092 15.3204 14.4803 14.3593 15.3043 13.1261C16.1283 11.8929 16.5681 10.4431 16.5681 8.96C16.5681 7.97518 16.3741 7 15.9972 6.09015C15.6203 5.18031 15.0679 4.35361 14.3715 3.65727C13.675 2.96093 12.8483 2.40859 11.9384 2.03178C11.0285 1.65497 10.0533 1.46108 9.06851 1.46118H9.06925Z",
    fill: "#404446"
  }), React.createElement("path", {
    d: "M9.06854 4.88381V10.1998",
    stroke: "#404446",
    strokeWidth: "1.10915",
    strokeMiterlimit: "10",
    strokeLinecap: "round"
  }), React.createElement("path", {
    d: "M9.06853 13.5582C9.48152 13.5582 9.81632 13.2234 9.81632 12.8104C9.81632 12.3974 9.48152 12.0626 9.06853 12.0626C8.65554 12.0626 8.32074 12.3974 8.32074 12.8104C8.32074 13.2234 8.65554 13.5582 9.06853 13.5582Z",
    fill: "#404446"
  }));
};
var Resolve = function Resolve(props) {
  return React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React.createElement("g", {
    filter: "url(#prefix__filter0_d_1452_27087)"
  }, React.createElement("path", {
    d: "M4 9a8 8 0 018-8h8a8 8 0 018 8v8a8 8 0 01-8 8h-8a8 8 0 01-8-8V9z",
    fill: "#04B300"
  }), React.createElement("path", {
    d: "M16 5c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 14.675c-3.675 0-6.675-3-6.675-6.675s3-6.675 6.675-6.675 6.675 3 6.675 6.675-3 6.675-6.675 6.675z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M18.2 10.525l-3.074 3-1.4-1.325c-.276-.275-.676-.275-.926 0s-.275.675 0 .925l1.675 1.6c.2.2.4.275.6.275.2 0 .476-.075.6-.275l3.4-3.275c.276-.275.276-.675 0-.925-.2-.25-.6-.25-.874 0z",
    fill: "#fff"
  })), React.createElement("defs", null, React.createElement("filter", {
    id: "prefix__filter0_d_1452_27087",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), React.createElement("feOffset", {
    dy: 3
  }), React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1452_27087"
  }), React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1452_27087",
    result: "shape"
  }))));
};
var ResolvedTick = function ResolvedTick(props) {
  return React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React.createElement("path", {
    d: "M0 8a8 8 0 0 1 8-8h8a8 8 0 0 1 8 8v8a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V8Z",
    fill: "#04B300"
  }), React.createElement("path", {
    d: "M12 4c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8Zm0 14.675c-3.675 0-6.675-3-6.675-6.675s3-6.675 6.675-6.675 6.675 3 6.675 6.675-3 6.675-6.675 6.675Z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "m14.2 9.525-3.075 3-1.4-1.325c-.275-.275-.675-.275-.925 0s-.275.675 0 .925l1.675 1.6c.2.2.4.275.6.275.2 0 .475-.075.6-.275l3.4-3.275c.275-.275.275-.675 0-.925-.2-.25-.6-.25-.875 0Z",
    fill: "#fff"
  }));
};
var PinIcon = function PinIcon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 14 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#3E3E48" : _ref$color;
  return React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M9.43398 0.00029194C9.04842 0.017907 8.67686 0.149976 8.36667 0.379651C8.05649 0.609327 7.82176 0.926196 7.69242 1.28984L6.75851 3.89134L4.157 4.82226C2.99821 5.23767 2.46999 6.6856 3.20815 7.42452L6.57472 10.7911C6.68809 10.9024 6.82258 10.9898 6.97026 11.0483C7.11795 11.1068 7.27585 11.1352 7.43466 11.1318C7.82035 11.1143 8.19208 10.9823 8.50241 10.7526C8.81273 10.5229 9.04758 10.206 9.17697 9.84223L10.1079 7.24072L12.7072 6.30905C13.8667 5.89439 14.3949 4.44571 13.656 3.70755L10.2917 0.340983C10.1784 0.229644 10.0439 0.142135 9.89618 0.0836203C9.74849 0.025106 9.59056 -0.00322757 9.43174 0.00029194H9.43398Z",
    fill: color
  }), React.createElement("path", {
    d: "M0.559548 14C0.448799 13.9997 0.340618 13.9667 0.24863 13.905C0.156643 13.8433 0.0849645 13.7558 0.042624 13.6534C0.000283568 13.5511 -0.0108251 13.4385 0.0106974 13.3299C0.0322198 13.2213 0.0854105 13.1214 0.16357 13.043L4.49692 8.70961C4.60255 8.60748 4.74407 8.55094 4.89099 8.55214C5.03792 8.55335 5.17849 8.61221 5.28243 8.71606C5.38637 8.8199 5.44537 8.96042 5.44671 9.10734C5.44806 9.25426 5.39165 9.39583 5.28962 9.50156L0.956274 13.8349C0.904312 13.8873 0.842505 13.9288 0.774415 13.9571C0.706325 13.9855 0.6333 14 0.559548 14Z",
    fill: color
  }));
};

var Icons = {
    __proto__: null,
    Like: Like,
    LikeFilled: LikeFilled,
    Dustbin: Dustbin,
    Menu: Menu,
    CopyToClipboard: CopyToClipboard,
    Reply: Reply,
    Report: Report,
    Resolve: Resolve,
    ResolvedTick: ResolvedTick,
    PinIcon: PinIcon
};

var _templateObject$3, _templateObject2$3, _templateObject3$2, _templateObject4$1;
var MenuContainer = /*#__PURE__*/styled.div(_templateObject$3 || (_templateObject$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    display: flex;\n    position: absolute;\n    top: 100%;\n    margin-top: -10px;\n    background-color: #fff;\n    border-radius: 6px;\n    right: ", ";\n    z-index: 1;\n    opacity: 0;\n    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.08);\n\n    &:focus-within,\n    &:hover {\n        opacity: 1;\n    }\n\n    ", "\n"])), function (_ref) {
  var align = _ref.align;
  return align === "right" ? "0" : "-16px";
}, function (_ref2) {
  var isExpanded = _ref2.isExpanded;
  return isExpanded ? "opacity: 1;" : "";
});
var Bubble = /*#__PURE__*/styled(View)(_templateObject2$3 || (_templateObject2$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    &:hover ", " {\n        opacity: 1;\n    }\n"])), MenuContainer);
var Wrapper$1 = /*#__PURE__*/styled.div(_templateObject3$2 || (_templateObject3$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    position: relative;\n    height: 32px;\n"])));
var DropdownList = /*#__PURE__*/styled(DropdownList$1).attrs({
  portal: true
})(_templateObject4$1 || (_templateObject4$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.08);\n    border: 0;\n    border-radius: 6px;\n    overflow: hidden;\n    margin-top: 2px;\n    top: 100%;\n\n    div[role=\"menuitem\"] {\n        padding: 5px 25px 5px 10px;\n    }\n"])));
var MessageBubblePrimaryButton = function MessageBubblePrimaryButton(_ref3) {
  var label = _ref3.label,
      icon = _ref3.icon,
      props = _objectWithoutPropertiesLoose(_ref3, ["label", "icon"]);

  return React.createElement(Tooltip, {
    label: label
  }, React.createElement(Button$1, Object.assign({
    size: "sm",
    iconOnly: true,
    clear: true,
    "aria-label": label
  }, props), icon));
};
var MessageBubbleSecondaryButton = function MessageBubbleSecondaryButton(_ref4) {
  var onClick = _ref4.onClick,
      label = _ref4.label,
      icon = _ref4.icon,
      props = _objectWithoutPropertiesLoose(_ref4, ["onClick", "label", "icon"]);

  return React.createElement(DropdownItem, Object.assign({
    onSelect: onClick
  }, props), React.createElement(Inline, {
    space: "xxsmall",
    wrap: "nowrap",
    verticalAlign: "center"
  }, icon, " ", React.createElement(Text, {
    size: "small",
    weight: "400"
  }, label)));
};
var MessageBubbleDesktop = function MessageBubbleDesktop(_ref5) {
  var position = _ref5.position,
      align = _ref5.align,
      primaryButtons = _ref5.primaryButtons,
      secondaryButtons = _ref5.secondaryButtons,
      children = _ref5.children,
      deleted = _ref5.deleted,
      _ref5$dataTestId = _ref5.dataTestId,
      dataTestId = _ref5$dataTestId === void 0 ? "" : _ref5$dataTestId;
  var theme = useChatTheme();
  return React.createElement(Bubble, Object.assign({}, getSharedBubbleProps({
    position: position,
    align: align,
    theme: theme
  }), {
    position: "relative",
    "data-test-id": dataTestId,
    opacity: deleted ? 0.5 : 1
  }), primaryButtons || secondaryButtons ? React.createElement(Dropdown, null, function (_ref6) {
    var isExpanded = _ref6.isExpanded;
    return React.createElement(MenuContainer, {
      align: align,
      isExpanded: isExpanded
    }, React.createElement(ButtonGroup, null, primaryButtons != null && primaryButtons.length ? primaryButtons : null, secondaryButtons != null && secondaryButtons.length ? React.createElement(Wrapper$1, null, React.createElement(DropdownButton, {
      "aria-label": "More options",
      size: "sm",
      iconOnly: true,
      clear: true
    }, React.createElement(Menu, null)), React.createElement(DropdownList, null, secondaryButtons)) : null));
  }) : null, children);
};

var MessageBubbleMobile = function MessageBubbleMobile(_ref) {
  var children = _ref.children,
      position = _ref.position,
      align = _ref.align,
      onLongPress = _ref.onLongPress,
      deleted = _ref.deleted,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? "" : _ref$dataTestId;

  var _usePress = usePress({}),
      pressProps = _usePress.pressProps,
      isPressed = _usePress.isPressed;

  var theme = useChatTheme();
  useEffect(function () {
    if (!isPressed) return;
    var id = setTimeout(function () {
      onLongPress();
    }, 500);
    return function () {
      clearTimeout(id);
    };
  }, [isPressed, onLongPress]);
  return React.createElement(View, Object.assign({
    "data-test-id": dataTestId
  }, pressProps, getSharedBubbleProps({
    position: position,
    align: align,
    theme: theme
  }), {
    opacity: deleted ? 0.5 : 1
  }), children);
};

var _templateObject$4, _templateObject2$4, _templateObject3$3, _templateObject4$2;
var Row = /*#__PURE__*/styled.button(_templateObject$4 || (_templateObject$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    display: block;\n    width: 100%;\n    text-align: left;\n    padding: 20px;\n    border: 0;\n    background-color: transparent;\n    outline: 0;\n    user-select: none;\n    --webkit-tap-highlight-color: #fff;\n\n    &:active {\n        background-color: ", ";\n    }\n"])), function (_ref) {
  var _theme$chat, _theme$chat$contextMe;

  var theme = _ref.theme;
  return theme == null ? void 0 : (_theme$chat = theme.chat) == null ? void 0 : (_theme$chat$contextMe = _theme$chat.contextMenu) == null ? void 0 : _theme$chat$contextMe.underlayColor;
});
var Backdrop = /*#__PURE__*/styled.div(_templateObject2$4 || (_templateObject2$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background: #a1aeb7;\n    position: absolute;\n    top: 0;\n    right: 0;\n    left: 0;\n    bottom: 0;\n    z-index: 98;\n    opacity: ", ";\n    transition: 0.3s ease opacity;\n    pointer-events: ", ";\n"])), function (_ref2) {
  var isOpen = _ref2.isOpen;
  return isOpen ? 0.2 : 0;
}, function (_ref3) {
  var isOpenDelayed = _ref3.isOpenDelayed;
  return isOpenDelayed ? "auto" : "none";
});
var Container = /*#__PURE__*/styled.div(_templateObject3$3 || (_templateObject3$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background-color: ", ";\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    transform: ", ";\n    border-top-right-radius: 12px;\n    border-top-left-radius: 12px;\n    padding-top: 8px;\n    z-index: 99;\n    transition: 0.3s ease transform;\n"])), function (_ref4) {
  var _theme$chat2, _theme$chat2$contextM;

  var theme = _ref4.theme;
  return theme == null ? void 0 : (_theme$chat2 = theme.chat) == null ? void 0 : (_theme$chat2$contextM = _theme$chat2.contextMenu) == null ? void 0 : _theme$chat2$contextM.backgroundColor;
}, function (_ref5) {
  var isOpen = _ref5.isOpen;
  return isOpen ? "none" : "translate3d(0, 100%, 0)";
});
var ReactionContainer = /*#__PURE__*/styled.button(_templateObject4$2 || (_templateObject4$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    width: 50px;\n    height: 50px;\n    justify-content: center;\n    align-items: center;\n    padding: 10px;\n    border-radius: 999px;\n    border: 1px;\n    border-style: solid;\n    border-color: ", ";\n    ", ";\n    transition: 0.2s ease-in-out opacity;\n    &:focus {\n        opacity: 0.5;\n    }\n    &:hover {\n        opacity: 0.5;\n    }\n"])), function (_ref6) {
  var _theme$chat3, _theme$chat3$contextM;

  var theme = _ref6.theme,
      hasReacted = _ref6.hasReacted;
  return hasReacted ? theme == null ? void 0 : (_theme$chat3 = theme.chat) == null ? void 0 : (_theme$chat3$contextM = _theme$chat3.contextMenu) == null ? void 0 : _theme$chat3$contextM.reactionBorderColor : "transparent";
}, function (_ref7) {
  var _theme$chat4, _theme$chat4$contextM, _theme$chat5, _theme$chat5$contextM;

  var theme = _ref7.theme;
  return theme != null && (_theme$chat4 = theme.chat) != null && (_theme$chat4$contextM = _theme$chat4.contextMenu) != null && _theme$chat4$contextM.reactionBackgroundColor ? "background-color: " + (theme == null ? void 0 : (_theme$chat5 = theme.chat) == null ? void 0 : (_theme$chat5$contextM = _theme$chat5.contextMenu) == null ? void 0 : _theme$chat5$contextM.reactionBackgroundColor) : undefined;
});
function ContextMenuReactions(_ref8) {
  var children = _ref8.children;
  return React.createElement(Box, {
    display: "flex",
    justifyContent: "space-evenly"
  }, children);
}
function ContextMenuReaction(_ref9) {
  var children = _ref9.children,
      onClick = _ref9.onClick,
      label = _ref9.label,
      hasReacted = _ref9.hasReacted;
  var ariaLabel = hasReacted ? "Remove reaction with '" + label + "' emoji" : "Click to react with '" + label + "' emoji";
  return React.createElement(ReactionContainer, {
    hasReacted: hasReacted,
    onClick: onClick,
    "aria-label": ariaLabel
  }, children);
}
function ContextMenuButton(_ref10) {
  var children = _ref10.children,
      onClick = _ref10.onClick,
      icon = _ref10.icon,
      rest = _objectWithoutPropertiesLoose(_ref10, ["children", "onClick", "icon"]);

  return React.createElement(Row, Object.assign({
    onClick: onClick
  }, rest), React.createElement(Columns, {
    space: "small",
    verticalAlign: "center"
  }, icon ? React.createElement(Column, {
    width: "content"
  }, icon) : null, React.createElement(Column, null, React.createElement(Text, {
    size: "large"
  }, children))));
}
function ContextMenuSeparator() {
  return React.createElement(Divider, null);
}
var ContextMenu = function ContextMenu(_ref11) {
  var isOpen = _ref11.isOpen,
      children = _ref11.children,
      onDismiss = _ref11.onDismiss,
      _ref11$hideCloseButto = _ref11.hideCloseButton,
      hideCloseButton = _ref11$hideCloseButto === void 0 ? false : _ref11$hideCloseButto;

  var _useState = useState(false),
      isOpenDelayed = _useState[0],
      setIsOpenDelayed = _useState[1];

  var _useState2 = useState(true),
      isClosedDelayed = _useState2[0],
      setIsClosedDelayed = _useState2[1]; // If we toggle pointerEvents to auto as soon as isOpen is true the de-press on the chat bubble
  // will register a press on the backdrop and immediately close the menu. This is why we use "isOpenDelayed"
  // variable to toggle pointerEvents so that backdrop is not clickable for half a second.


  useEffect(function () {
    if (!isOpen) {
      setIsOpenDelayed(isOpen);
      return;
    }

    var id = setTimeout(function () {
      setIsOpenDelayed(isOpen);
    }, 600);
    return function () {
      clearTimeout(id);
    };
  }, [isOpen]); // We want to remove the children from the DOM after the closing animation has run
  // so we wait 300ms and flip the isOpen. When isOpen is true we set isClosed is false instantly
  // because we want to render the buttons on screen and run the opening animation as soon as possible.

  useEffect(function () {
    if (isOpen) {
      setIsClosedDelayed(!isOpen);
      return;
    }

    var id = setTimeout(function () {
      setIsClosedDelayed(!isOpen);
    }, 300);
    return function () {
      clearTimeout(id);
    };
  }, [isOpen]);
  return React.createElement(React.Fragment, null, React.createElement(Backdrop, {
    "aria-hidden": true,
    isOpen: isOpen,
    onClick: onDismiss,
    isOpenDelayed: isOpenDelayed
  }), React.createElement(Container, {
    "aria-hidden": !isOpen,
    // We wait for isClosedDelayed to be false so we know the contents are rendered on screen
    // before we run the opening animation
    isOpen: isOpen && !isClosedDelayed
  }, !hideCloseButton ? React.createElement(CloseButton, {
    onClick: onDismiss,
    "aria-label": "Close menu"
  }) : null, isClosedDelayed ? null : children));
};

var placeholderAvatar = /*#__PURE__*/React.createElement(View, {
  flexShrink: 0,
  w: [35, 40],
  h: [35, 40],
  borderRadius: "xlarge",
  bgColor: "solitude",
  borderColor: "deepSolitude",
  borderWidth: 2,
  opacity: 1,
  marginX: ["xxsmall", "xsmall"]
});
var avatarSpacer = /*#__PURE__*/React.createElement(Box, {
  w: [35, 40],
  marginX: ["xxsmall", "xsmall"],
  flexShrink: 0
}); // We only want the avatar to be shown on messages when its at the top of a group of messages
// or the message is an orphaned message, i.e. on its own, or its right aligned

var shouldShowAvatar = function shouldShowAvatar(_ref) {
  var position = _ref.position,
      align = _ref.align,
      avatar = _ref.avatar;

  if (align === "right") {
    return null;
  } else if (position !== "top" && position !== "orphan") {
    return avatarSpacer;
  }

  return avatar;
};

var _templateObject$5, _templateObject2$5, _templateObject3$4, _templateObject4$3;
var ReactionAmount = /*#__PURE__*/styled.div(_templateObject$5 || (_templateObject$5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    font-size: 12px;\n    margin-left: 4px;\n    font-variant-numeric: tabular-nums;\n"])));
var ReactionIcon = /*#__PURE__*/styled.span(_templateObject2$5 || (_templateObject2$5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    display: contents;\n"])));
var ReactionContainer$1 = /*#__PURE__*/styled.button(_templateObject3$4 || (_templateObject3$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    padding: ", ";\n    background: ", ";\n    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);\n    display: flex;\n    align-items: center;\n    line-height: 16px;\n    ", "\n    border-color: ", ";\n    border-radius: ", ";\n    &:hover {\n        cursor: pointer;\n        opacity: 0.7;\n    }\n    transition: 0.2s ease-in-out opacity;\n"])), function (_ref) {
  var padding = _ref.padding;
  return padding === "small" ? "4px" : "3px 6px";
}, function (_ref2) {
  var _theme$chat, _theme$chat$reaction, _theme$chat2, _theme$chat2$reaction;

  var theme = _ref2.theme,
      hasReacted = _ref2.hasReacted;
  return hasReacted ? theme == null ? void 0 : (_theme$chat = theme.chat) == null ? void 0 : (_theme$chat$reaction = _theme$chat.reaction) == null ? void 0 : _theme$chat$reaction.reactedBackgroundColor : theme == null ? void 0 : (_theme$chat2 = theme.chat) == null ? void 0 : (_theme$chat2$reaction = _theme$chat2.reaction) == null ? void 0 : _theme$chat2$reaction.backgroundColor;
}, function (_ref3) {
  var _theme$chat3, _theme$chat3$reaction, _theme$chat4, _theme$chat4$reaction;

  var theme = _ref3.theme;
  return theme != null && (_theme$chat3 = theme.chat) != null && (_theme$chat3$reaction = _theme$chat3.reaction) != null && _theme$chat3$reaction.border ? "\n                  border: " + (theme == null ? void 0 : (_theme$chat4 = theme.chat) == null ? void 0 : (_theme$chat4$reaction = _theme$chat4.reaction) == null ? void 0 : _theme$chat4$reaction.border) + ";\n              " : null;
}, function (_ref4) {
  var _theme$chat5, _theme$chat5$reaction, _theme$chat6, _theme$chat6$reaction;

  var theme = _ref4.theme,
      hasReacted = _ref4.hasReacted;
  return hasReacted ? theme == null ? void 0 : (_theme$chat5 = theme.chat) == null ? void 0 : (_theme$chat5$reaction = _theme$chat5.reaction) == null ? void 0 : _theme$chat5$reaction.reactedBorderColor : theme == null ? void 0 : (_theme$chat6 = theme.chat) == null ? void 0 : (_theme$chat6$reaction = _theme$chat6.reaction) == null ? void 0 : _theme$chat6$reaction.backgroundColor;
}, function (_ref5) {
  var borderRadius = _ref5.borderRadius;
  return borderRadius === "small" ? "8px" : "16px";
});
var PinnedContainer = /*#__PURE__*/styled.div(_templateObject4$3 || (_templateObject4$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    padding: 5px 6px;\n    background: ", ";\n    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);\n    display: flex;\n    align-items: center;\n    line-height: 16px;\n    ", "\n    border-color: ", ";\n    border-radius: ", ";\n"])), function (_ref6) {
  var _theme$chat7, _theme$chat7$reaction;

  var theme = _ref6.theme;
  return theme == null ? void 0 : (_theme$chat7 = theme.chat) == null ? void 0 : (_theme$chat7$reaction = _theme$chat7.reaction) == null ? void 0 : _theme$chat7$reaction.pinnedBackgroundColor;
}, function (_ref7) {
  var _theme$chat8, _theme$chat8$reaction, _theme$chat9, _theme$chat9$reaction;

  var theme = _ref7.theme;
  return theme != null && (_theme$chat8 = theme.chat) != null && (_theme$chat8$reaction = _theme$chat8.reaction) != null && _theme$chat8$reaction.border ? "\n                  border: " + (theme == null ? void 0 : (_theme$chat9 = theme.chat) == null ? void 0 : (_theme$chat9$reaction = _theme$chat9.reaction) == null ? void 0 : _theme$chat9$reaction.border) + ";\n              " : null;
}, function (_ref8) {
  var _theme$chat10, _theme$chat10$reactio;

  var theme = _ref8.theme;
  return theme == null ? void 0 : (_theme$chat10 = theme.chat) == null ? void 0 : (_theme$chat10$reactio = _theme$chat10.reaction) == null ? void 0 : _theme$chat10$reactio.reactedBorderColor;
}, function (_ref9) {
  var borderRadius = _ref9.borderRadius;
  return borderRadius === "small" ? "8px" : "16px";
});

var Reaction = function Reaction(_ref10) {
  var children = _ref10.children,
      _ref10$space = _ref10.space,
      space = _ref10$space === void 0 ? "xxsmall" : _ref10$space;
  return React.createElement(Box, {
    paddingLeft: "xsmall",
    transform: "translateY(-5px)"
  }, React.createElement(Inline, {
    space: space
  }, children));
};

var Likes = function Likes(_ref11) {
  var isLiked = _ref11.isLiked,
      likes = _ref11.likes,
      _ref11$color = _ref11.color,
      color = _ref11$color === void 0 ? null : _ref11$color,
      _ref11$padding = _ref11.padding,
      padding = _ref11$padding === void 0 ? "small" : _ref11$padding;
  return React.createElement(ReactionContainer$1, {
    padding: padding
  }, React.createElement(ReactionIcon, null, isLiked ? React.createElement(LikeFilled, {
    fill: color
  }) : React.createElement(Like, {
    fill: color
  })), React.createElement(ReactionAmount, {
    color: color
  }, likes, " ", React.createElement(VisuallyHidden, null, "likes")));
};

var Resolved = function Resolved(_ref12) {
  var isResolved = _ref12.isResolved,
      dataTestId = _ref12.dataTestId;
  return React.createElement(ReactionIcon, {
    "data-test-id": dataTestId
  }, isResolved ? React.createElement(ResolvedTick, null) : null);
};

var Pinned = function Pinned(_ref13) {
  var isPinned = _ref13.isPinned,
      _ref13$borderRadius = _ref13.borderRadius,
      borderRadius = _ref13$borderRadius === void 0 ? "small" : _ref13$borderRadius,
      iconProps = _ref13.iconProps;
  return isPinned ? React.createElement(PinnedContainer, {
    borderRadius: borderRadius
  }, React.createElement(ReactionIcon, null, React.createElement(PinIcon, Object.assign({
    color: "white"
  }, iconProps)))) : null;
};

var Emoji = function Emoji(_ref14) {
  var children = _ref14.children,
      count = _ref14.count,
      hasReacted = _ref14.hasReacted,
      _ref14$label = _ref14.label,
      label = _ref14$label === void 0 ? "Reaction" : _ref14$label,
      _ref14$color = _ref14.color,
      color = _ref14$color === void 0 ? null : _ref14$color,
      _ref14$borderRadius = _ref14.borderRadius,
      borderRadius = _ref14$borderRadius === void 0 ? "small" : _ref14$borderRadius,
      _ref14$padding = _ref14.padding,
      padding = _ref14$padding === void 0 ? "small" : _ref14$padding,
      _ref14$onClick = _ref14.onClick,
      onClick = _ref14$onClick === void 0 ? function () {} : _ref14$onClick;
  var ariaLabel = count + " " + (count === 1 ? "person" : "people") + " reacted with '" + label + "' emoji. " + (hasReacted ? "Click to remove reaction" : "Click to react") + ".";
  return React.createElement(ReactionContainer$1, {
    hasReacted: hasReacted,
    "aria-label": ariaLabel,
    borderRadius: borderRadius,
    onClick: onClick,
    padding: padding
  }, children, React.createElement(ReactionAmount, {
    color: color
  }, count));
};

Reaction.Pinned = Pinned;
Reaction.Likes = Likes;
Reaction.Emoji = Emoji; // web only

Reaction.Resolved = Resolved;

var defaultTheme = {
  Button: {
    colors: {
      chat: {
        color: "#3e3e48",
        bgColor: "#c2d1d9",
        borderColor: "transparent",
        hoverBgColor: "#c2d1d9",
        outlineColor: "#3e3e48",
        clearColor: "#3e3e48",
        clearHoverBgColor: "#c2d1d9"
      },
      activeChat: {
        color: "#9b570b",
        bgColor: "#ffe5c8",
        borderColor: "transparent",
        hoverBgColor: "#9b570b",
        outlineColor: "#9b570b",
        clearColor: "#9b570b",
        clearHoverBgColor: "#ffe5c8"
      }
    }
  },
  chat: {
    button: {
      backgroundColorActive: "#ffe5c8",
      backgroundColor: "#c2d1d9",
      colorActive: "#9b570b",
      color: "#3e3e48"
    },
    contextMenu: {
      backgroundColor: "#fff",
      backdropColor: "#a1aeb7",
      underlayColor: "#f1f1f1",
      reactionBackgroundColor: "#F3F5F5",
      reactionBorderColor: "#F3F5F5"
    },
    disabled: {
      backgroundColor: "#c2d1d9"
    },
    footer: {
      backgroundColor: "#f2f5f7",
      brb: "none"
    },
    input: {
      color: "#3e3e48",
      backgroundColor: "#fff",
      boxShadow: "0px 2px 12px rgba(0, 0, 0, 0.08)",
      paddingTop: "10px",
      paddingBottom: "10px",
      placeholderColor: "#3e3e48",
      borderRadius: "24px"
    },
    message: {
      backgroundColor: "#ffe5c8",
      altBackgroundColor: "#fff",
      linkColor: "#6852FB",
      altLinkColor: "#6852FB",
      textColor: "#424b5a",
      altTextColor: "#424b5a"
    },
    scroll: {
      backgroundColor: "#f2f5f7",
      gradientBgColorTop: "rgba(242, 245, 247,0)",
      gradientBgColorBottom: "rgba(242, 245, 247,1)"
    },
    quote: {
      backgroundColor: "#fff",
      altBackgroundColor: "#f1f1f1",
      highlightColor: "#9B570B",
      altBorderColor: "#FFE5C8",
      authorColor: "#9B570B",
      altAuthorColor: "#9B570B",
      bodyColor: "#3e3e48",
      altBodyColor: "#3e3e48"
    },
    reaction: {
      backgroundColor: "#fafafa",
      pinnedBackgroundColor: "#5140C9",
      pinnedBorderColor: "#5140C9",
      border: null,
      reactedBackgroundColor: "#5140C9",
      reactedBorderColor: "#5140C9"
    }
  }
};

function ChatThemeProvider(_ref) {
  var children = _ref.children,
      theme = _ref.theme;
  return React.createElement(PatronThemeProvider, {
    theme: deepMerge(defaultTheme, theme)
  }, children);
}

var _templateObject$6;
var Link = /*#__PURE__*/styled.a(_templateObject$6 || (_templateObject$6 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    color: ", ";\n"])), function (_ref) {
  var _theme$chat, _theme$chat$message, _theme$chat2, _theme$chat2$message;

  var theme = _ref.theme,
      align = _ref.align;
  return align === "right" ? theme == null ? void 0 : (_theme$chat = theme.chat) == null ? void 0 : (_theme$chat$message = _theme$chat.message) == null ? void 0 : _theme$chat$message.linkColor : theme == null ? void 0 : (_theme$chat2 = theme.chat) == null ? void 0 : (_theme$chat2$message = _theme$chat2.message) == null ? void 0 : _theme$chat2$message.altLinkColor;
});

var MessageText = function MessageText(_ref2) {
  var _theme$chat3, _theme$chat3$message, _theme$chat4, _theme$chat4$message;

  var deleted = _ref2.deleted,
      isSenderBlocked = _ref2.isSenderBlocked,
      align = _ref2.align,
      children = _ref2.children;
  var theme = usePatronTheme();
  return React.createElement(Text, {
    fontStyle: deleted || isSenderBlocked ? "italic" : undefined,
    whiteSpace: "pre-wrap",
    color: align === "right" ? theme == null ? void 0 : (_theme$chat3 = theme.chat) == null ? void 0 : (_theme$chat3$message = _theme$chat3.message) == null ? void 0 : _theme$chat3$message.textColor : theme == null ? void 0 : (_theme$chat4 = theme.chat) == null ? void 0 : (_theme$chat4$message = _theme$chat4.message) == null ? void 0 : _theme$chat4$message.altTextColor
  }, React.createElement(Linkify, {
    componentDecorator: function componentDecorator(href, text) {
      return React.createElement(Link, {
        target: "_blank",
        rel: "noopener noreferrer",
        align: align,
        href: href
      }, text);
    }
  }, isSenderBlocked ? "This user was removed" : children));
};

var Swipe = function Swipe(_ref) {
  var as = _ref.as,
      children = _ref.children,
      onSwipe = _ref.onSwipe,
      threshold = _ref.threshold,
      align = _ref.align,
      enabled = _ref.enabled;
  var swipeRef = useRef(null);
  useSwipeHorizontal(onSwipe, align, swipeRef, threshold, enabled);
  return React.createElement(Box, {
    as: as,
    ref: swipeRef
  }, children);
};
Swipe.defaultProps = {
  threshold: 30,
  enabled: true
};
/**
 * elasticDrag helps the drag animation feel more natural
 * by reducing the amount we can drag pass the threshold.
 *
 * @param {Number} threshold
 * @param {Number} distanceX
 * @returns Number - new distance we should drag
 */

function elasticDrag(threshold, distanceX) {
  return threshold * Math.sqrt(distanceX / threshold);
}
/**
 * hasPassedTheThreshold determines whether the threshold has been passed.
 * Depending on the align the distance might be a negative or a positive
 * number.
 *
 * @param {String} align
 * @param {Event} event - pan event
 * @param {Number} threshold
 * @returns
 */


function hasPassedTheThreshold(align, event, threshold) {
  return align === "left" && event.deltaX > threshold || align === "right" && Math.abs(event.deltaX) > threshold;
}
/**
 *
 *
 * @isHorizontal
 * @param angle: the angle you want to test in degrees
 * @param threshold: the tolerated deviation from 0, in degrees
 * @returns boolean
 */


var isHorizontal = function isHorizontal(angle, threshold) {
  return Math.abs(angle) < threshold || Math.abs(angle) > 180 - threshold;
};
/**
 * useSwipeHorizontal - custom Hook to move an element (ref),
 * when swiping a minimum distance of threshold.
 * When the drag is released and the threshold is passed, element returns
 * to its original position and onSwipe is called.
 *
 * @param @param {*} {onSwipe, align, swipeRef, threshold, enabled}
 * @returns custom hook
 */


function useSwipeHorizontal(onSwipe, align, swipeRef, threshold, enabled) {
  useEffect(function () {
    if (!enabled) return; // for backwards compat we disable this hook when the onSwipe is not passed

    if (!onSwipe || align === "center") return;
    if (!swipeRef.current) return;
    var hammertime = new Hammer(swipeRef.current);

    var resetDragPosition = function resetDragPosition() {
      // we must apply transition in a render loop before applying the animation
      if (!swipeRef.current) return;
      swipeRef.current.style.transition = ".3s ease transform";
      requestAnimationFrame(function () {
        // in the next render loop we apply the animation
        if (!swipeRef.current) return;
        swipeRef.current.style.transform = "translate3d(0, 0, 0)";
      });
    };

    hammertime.on("pan", function (event) {
      if (align === "left" && event.deltaX < 0) return;
      if (align === "right" && event.deltaX > 0) return; // when right aligned the deltaX is a negative number

      var distanceX = Math.abs(event.deltaX); // when a distance is small we are not sure of the angle

      var isHorizontalSwipe = distanceX < 20 || isHorizontal(event.angle, 22.5);

      if (isHorizontalSwipe) {
        requestAnimationFrame(function () {
          if (!swipeRef.current) return;
          var x = distanceX > threshold ? elasticDrag(threshold, distanceX) : distanceX;
          swipeRef.current.style.transform = "translate3d(" + (align === "left" ? x : -x) + "px, 0, 0)";
        });
      }
    });
    hammertime.on("panstart", function () {
      if (!swipeRef.current) return; // we must remove the transition while we are dragging

      swipeRef.current.style.transition = "none";
    });
    hammertime.on("panend pancancel", function (event) {
      if (hasPassedTheThreshold(align, event, threshold)) {
        onSwipe();
      }

      resetDragPosition();
    });
    return function () {
      resetDragPosition();
      hammertime.off("pan panstart panend pancancel");
    };
  }, [onSwipe, align, swipeRef, threshold, enabled]);
}

export { ChatContainer, ChatFooter, ChatInput, ChatScroll, ChatThemeProvider, ContextMenu, ContextMenuButton, ContextMenuReaction, ContextMenuReactions, ContextMenuSeparator, Icons, MessageBubbleDesktop, MessageBubbleMobile, MessageBubblePrimaryButton, MessageBubbleSecondaryButton, MessageQuote, MessageRow, MessageText, Reaction, Swipe, avatarSpacer, getMessageSequencePosition, placeholderAvatar, shouldShowAvatar, useChatTheme };
//# sourceMappingURL=chat-ui.esm.js.map
